import axios from 'axios';
import config from '../../config'

let baseURL = '';

if (process.env.NODE_ENV === 'production'){
    baseURL = config.build.baseURL
}else{
    baseURL = config.dev.baseURL
}

const axiosCommon = axios.create({
    baseURL: baseURL
})

axiosCommon.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = token
    }
    return config
}, function (error) {
    return Promise.reject(error)
});

axiosCommon.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
});

export default axiosCommon



// WEBPACK FOOTER //
// ./src/axios-common/axios-common.js